import { SettingLandingBannersBreadsInformationContainer } from "..";

export const SettingLandingBannersBreadsMainContainer = () => {
  return (
    <div className="productDetailMainContainer">
      <SettingLandingBannersBreadsInformationContainer />
    </div>
  );
};
